import React from 'react';

const Grape = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M8.89 17.198a2 2 0 1 0-2.051-3.433 2 2 0 0 0 2.052 3.433ZM13.183 14.634A2 2 0 1 0 11.13 11.2a2 2 0 0 0 2.052 3.434ZM12.66 19.606a2 2 0 1 0-2.053-3.434 2 2 0 0 0 2.052 3.434ZM17.474 12.068a2 2 0 1 0-2.052-3.433 2 2 0 0 0 2.052 3.433ZM16.951 17.041a2 2 0 1 0-2.052-3.434 2 2 0 0 0 2.052 3.434ZM17.287 21.5a2 2 0 1 0-2.052-3.433 2 2 0 0 0 2.052 3.433ZM10.874 4.172c.618.75.612 1.776-.014 2.29-.625.515-1.633.324-2.25-.427-.805-.977-1.477-4.103-1.477-4.103s2.938 1.262 3.741 2.24Z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M14.233 4c-1.846.983-5.26 4.017-4.15 8.29"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M12.38 5.7c-.056.706.421 2.255 2.77 2.798"
    />
  </svg>
);

export default Grape;
